var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.640625C7.184 0.640625 0 7.38136 0 15.6534C0 23.9254 7.184 30.6662 16 30.6662C24.816 30.6662 32 23.9254 32 15.6534C32 7.38136 24.816 0.640625 16 0.640625ZM21.376 19.1063C21.84 19.5417 21.84 20.2623 21.376 20.6977C21.136 20.9229 20.832 21.028 20.528 21.028C20.224 21.028 19.92 20.9229 19.68 20.6977L16 17.2447L12.32 20.6977C12.08 20.9229 11.776 21.028 11.472 21.028C11.168 21.028 10.864 20.9229 10.624 20.6977C10.16 20.2623 10.16 19.5417 10.624 19.1063L14.304 15.6534L10.624 12.2005C10.16 11.7651 10.16 11.0445 10.624 10.6091C11.088 10.1737 11.856 10.1737 12.32 10.6091L16 14.062L19.68 10.6091C20.144 10.1737 20.912 10.1737 21.376 10.6091C21.84 11.0445 21.84 11.7651 21.376 12.2005L17.696 15.6534L21.376 19.1063Z",
    fill: "#F6AF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0618f909ec40c29cc815d83df6b6be75.svg";
export { ForwardRef as ReactComponent };